import React, { Component } from 'react';
import axios from 'axios';
import {
    Segment,
    Form,
    Input,
    Dropdown,
    Button,
    Table,
    Icon,
    Label,
    Header,
    Grid,
    Message,
    Dimmer,
    Loader
} from 'semantic-ui-react';
import config from '../../config';

class HeroBrandAutomation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            newBrandName: '',
            secPriorityCol: '',
            brands: [],
            clusterMasterUrl: '',
            selectedBrandName: '',
            selectedBrand: null,
            uploadingVT: false,
            vtFile: null,
            loading: false,
            message: null,
            error: null,
            headerMappingUrl: '',
            uploadingMapping: false,
            mappingFile: null
        };
    }

    componentDidMount() {
        if (this.props.templateId) {
            this.fetchDetails();
        }
    }

    componentWillUnmount() {
        this.stopPolling();
    }

    startPolling = () => {
        if (!this.pollInterval) {
            this.pollInterval = setInterval(() => {
                if (this.props.templateId) {
                    this.fetchDetails(true);
                }
            }, 4000);
        }
    };

    stopPolling = () => {
        if (this.pollInterval) {
            clearInterval(this.pollInterval);
            this.pollInterval = null;
        }
    };

    componentDidUpdate(prevProps) {
        if (prevProps.templateId !== this.props.templateId && this.props.templateId) {
            this.setState({
                newBrandName: '',
                secPriorityCol: '',
                selectedBrandName: '',
                selectedBrand: null
            }, () => {
                this.stopPolling();
                this.fetchDetails();
            });
        }
    }

    fetchDetails = (silent = false) => {
        const { templateId } = this.props;
        if (!templateId) return;

        if (!silent) {
            this.setState({ loading: true });
        }

        axios.get(`${config.api_url}/admin/v1/disbursement/heroBrand/getDetails?templateId=${templateId}`)
        .then(res => {
            if (res.data && res.data.status) {
                const brands = res.data.brands || [];
                const clusterMasterUrl = res.data.clusterMasterUrl || '';
                const headerMappingUrl = res.data.headerMappingUrl || '';

                let selectedBrand = this.state.selectedBrand;
                if (this.state.selectedBrandName) {
                    selectedBrand = brands.find(b => b.brandName === this.state.selectedBrandName) || null;
                } else if (brands.length > 0) {
                    selectedBrand = brands[0];
                }

                this.setState({
                    brands,
                    clusterMasterUrl,
                    headerMappingUrl,
                    selectedBrand,
                    selectedBrandName: selectedBrand ? selectedBrand.brandName : '',
                    loading: false
                }, () => {
                    const hasProcessing = brands.some(b => b.status === 'Processing');
                    if (hasProcessing) {
                        this.startPolling();
                    } else {
                        this.stopPolling();
                    }
                });
            } else {
                this.setState({ loading: false });
            }
        })
        .catch(err => {
            console.error('Error fetching Hero Brand details:', err);
            this.setState({ loading: false });
        });
    };

    handleCreateMapping = () => {
        const { newBrandName, secPriorityCol } = this.state;
        const { templateId } = this.props;

        if (!newBrandName.trim()) {
            this.setState({ error: 'Please enter a brand name' });
            return;
        }

        this.setState({ loading: true, error: null, message: null });

        axios.post(`${config.api_url}/admin/v1/disbursement/heroBrand/createMapping`, {
            templateId,
            brandName: newBrandName.trim(),
            secPriorityCol
        })
        .then(res => {
            if (res.data && res.data.status) {
                this.setState({
                    newBrandName: '',
                    message: res.data.message,
                    loading: false
                }, () => this.fetchDetails());
            } else {
                this.setState({ error: res.data.message || 'Failed to create mapping', loading: false });
            }
        })
        .catch(err => {
            console.error('Error creating mapping:', err);
            this.setState({ error: 'Error creating mapping', loading: false });
        });
    };

    handleBrandChange = (e, { value }) => {
        const selectedBrand = this.state.brands.find(b => b.brandName === value) || null;
        this.setState({
            selectedBrandName: value,
            selectedBrand
        });
    };

    handleVTFileSelect = (e) => {
        if (e.target.files && e.target.files[0]) {
            this.setState({ vtFile: e.target.files[0] });
        }
    };

    handleUploadVT = () => {
        const { vtFile, selectedBrandName } = this.state;
        const { templateId } = this.props;

        if (!vtFile) {
            alert('Please select a file to upload');
            return;
        }

        const formData = new FormData();
        formData.append('templateId', templateId);
        formData.append('brandName', selectedBrandName);
        formData.append('file', vtFile);

        this.setState({ uploadingVT: true, error: null, message: null });

        axios.post(`${config.api_url}/admin/v1/disbursement/heroBrand/uploadVT`, formData)
        .then(res => {
            if (res.data && res.data.status) {
                this.setState({
                    uploadingVT: false,
                    vtFile: null,
                    message: 'Visibility Tracker uploaded successfully!'
                }, () => this.fetchDetails());
            } else {
                this.setState({ uploadingVT: false, error: res.data.message || 'Upload failed' });
            }
        })
        .catch(err => {
            console.error('Error uploading VT:', err);
            this.setState({ uploadingVT: false, error: 'Error uploading Visibility Tracker' });
        });
    };

    handleMappingFileSelect = (e) => {
        if (e.target.files && e.target.files[0]) {
            this.setState({ mappingFile: e.target.files[0] });
        }
    };

    handleUploadMapping = () => {
        const { mappingFile } = this.state;
        const { templateId } = this.props;

        if (!mappingFile) {
            alert('Please select a Header Mapping file to upload');
            return;
        }

        const formData = new FormData();
        formData.append('templateId', templateId);
        formData.append('file', mappingFile);

        this.setState({ uploadingMapping: true, error: null, message: null });

        axios.post(`${config.api_url}/admin/v1/disbursement/heroBrand/uploadHeaderMapping`, formData)
        .then(res => {
            if (res.data && res.data.status) {
                this.setState({
                    uploadingMapping: false,
                    mappingFile: null,
                    message: 'Header Mapping file uploaded successfully!'
                }, () => this.fetchDetails());
            } else {
                this.setState({ uploadingMapping: false, error: res.data.message || 'Upload failed' });
            }
        })
        .catch(err => {
            console.error('Error uploading Header Mapping:', err);
            this.setState({ uploadingMapping: false, error: 'Error uploading Header Mapping file' });
        });
    };

    handleStartProcess = () => {
        const { selectedBrandName } = this.state;
        const { templateId } = this.props;

        if (!selectedBrandName) {
            alert('Please select a brand');
            return;
        }

        this.setState({ loading: true, error: null, message: null });

        axios.post(`${config.api_url}/admin/v1/disbursement/heroBrand/processBrand`, {
            templateId,
            brandName: selectedBrandName
        })
        .then(res => {
            if (res.data && res.data.status) {
                this.setState({
                    message: res.data.message,
                    loading: false
                }, () => {
                    this.startPolling();
                    this.fetchDetails();
                });
            } else {
                this.setState({ error: res.data.message || 'Failed to start processing', loading: false });
            }
        })
        .catch(err => {
            console.error('Error starting process:', err);
            this.setState({ error: 'Error starting processing', loading: false });
        });
    };

    handleDownload = (url) => {
        if (!url) {
            alert('File not available for download');
            return;
        }
        window.open(url, '_blank');
    };

    render() {
        const {
            newBrandName,
            secPriorityCol,
            brands,
            clusterMasterUrl,
            headerMappingUrl,
            selectedBrandName,
            selectedBrand,
            loading,
            uploadingVT,
            uploadingMapping,
            mappingFile,
            message,
            error
        } = this.state;

        const brandOptions = brands.map(b => ({
            key: b.brandName,
            value: b.brandName,
            text: b.brandName
        }));

        const secPriorityOptions = [
            { key: 'sec1', value: 'sec1', text: 'sec1' },
            { key: 'sec2', value: 'sec2', text: 'sec2' },
            { key: 'NonSec', value: 'NonSec', text: 'NonSec' }
        ];

        return (
            <Segment style={{ marginTop: 20, padding: 20 }}>
                {loading && (
                    <Dimmer active inverted>
                        <Loader>Loading Hero Brand details...</Loader>
                    </Dimmer>
                )}

                <Header as="h3" color="blue">
                    Hero Brand Automation Management
                </Header>

                {message && <Message positive dismissible onDismiss={() => this.setState({ message: null })} content={message} />}
                {error && <Message negative dismissible onDismiss={() => this.setState({ error: null })} content={error} />}

                {/* Section 1: Create Brand based sector priority mapping */}
                <Segment secondary style={{ marginTop: 10 }}>
                    <Header as="h4">Create Brand based sector priority mapping</Header>
                    <Form size="small">
                        <Form.Group widths="equal">
                            <Form.Input
                                label="Brand Name"
                                placeholder="e.g. OralB, Vicks"
                                value={newBrandName}
                                onChange={(e, { value }) => this.setState({ newBrandName: value })}
                            />
                            <Form.Dropdown
                                label="Sector Priority Column"
                                selection
                                placeholder="Select Sector Priority Column"
                                options={secPriorityOptions}
                                value={secPriorityCol}
                                onChange={(e, { value }) => this.setState({ secPriorityCol: value })}
                            />
                            <Form.Field style={{ paddingTop: 24 }}>
                                <Button color="teal" onClick={this.handleCreateMapping}>
                                    <Icon name="plus" /> Create Mapping
                                </Button>
                            </Form.Field>
                        </Form.Group>
                    </Form>
                </Segment>

                {/* Header Mapping Section (Template Specific) */}
                <Segment secondary style={{ marginTop: 10 }}>
                    <Header as="h4">Header Mapping (Template Specific)</Header>
                    <Grid verticalAlign="middle">
                        <Grid.Column width={6}>
                            <Label color={headerMappingUrl ? 'green' : 'yellow'} size="large">
                                {headerMappingUrl ? 'Mapping File Uploaded' : 'Mapping File Missing'}
                            </Label>
                        </Grid.Column>
                        <Grid.Column width={10} textAlign="right">
                            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '10px' }}>
                                <input
                                    type="file"
                                    onChange={this.handleMappingFileSelect}
                                    style={{ width: 220 }}
                                />
                                <Button
                                    icon
                                    color="blue"
                                    size="small"
                                    onClick={this.handleUploadMapping}
                                    loading={uploadingMapping}
                                    disabled={!mappingFile}
                                >
                                    <Icon name="upload" /> Upload
                                </Button>
                                <Button
                                    icon
                                    color="green"
                                    size="small"
                                    disabled={!headerMappingUrl}
                                    onClick={() => this.handleDownload(headerMappingUrl)}
                                >
                                    <Icon name="download" /> Download
                                </Button>
                            </div>
                        </Grid.Column>
                    </Grid>
                </Segment>

                {/* Section 2: Automation Card & Brand Selector */}
                <Segment style={{ marginTop: 20 }}>
                    <Grid columns={2} verticalAlign="middle">
                        <Grid.Column width={6}>
                            <Header as="h4">Select Brand</Header>
                            <Dropdown
                                placeholder="Select Brand"
                                fluid
                                selection
                                options={brandOptions}
                                value={selectedBrandName}
                                onChange={this.handleBrandChange}
                                disabled={brandOptions.length === 0}
                            />
                        </Grid.Column>
                    </Grid>

                    {selectedBrand && (
                        <div style={{ marginTop: 20 }}>
                            <Table celled striped>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell>Input</Table.HeaderCell>
                                        <Table.HeaderCell>Status</Table.HeaderCell>
                                        <Table.HeaderCell>Upload</Table.HeaderCell>
                                        <Table.HeaderCell>Download</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {/* 1. Visibility Tracker Row */}
                                    <Table.Row>
                                        <Table.Cell>
                                            <strong>1. Visibility Tracker</strong>
                                        </Table.Cell>
                                        <Table.Cell>
                                            <Label color={selectedBrand.vt_file ? 'green' : 'yellow'}>
                                                {selectedBrand.vt_file ? 'Uploaded' : 'Pending'}
                                            </Label>
                                        </Table.Cell>
                                        <Table.Cell>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <input
                                                    type="file"
                                                    onChange={this.handleVTFileSelect}
                                                    style={{ width: 180 }}
                                                />
                                                <Button
                                                    icon
                                                    color="blue"
                                                    size="tiny"
                                                    onClick={this.handleUploadVT}
                                                    loading={uploadingVT}
                                                    disabled={!this.state.vtFile}
                                                >
                                                    <Icon name="upload" />
                                                </Button>
                                            </div>
                                        </Table.Cell>
                                        <Table.Cell>
                                            <Button
                                                icon
                                                color="green"
                                                size="tiny"
                                                disabled={!selectedBrand.vt_file}
                                                onClick={() => this.handleDownload(selectedBrand.vt_file)}
                                            >
                                                <Icon name="download" />
                                            </Button>
                                        </Table.Cell>
                                    </Table.Row>

                                    {/* 2. Cluster Master Row */}
                                    <Table.Row>
                                        <Table.Cell>
                                            <strong>2. Cluster Master</strong>
                                        </Table.Cell>
                                        <Table.Cell>
                                            <Label color={clusterMasterUrl ? 'green' : 'grey'}>
                                                {clusterMasterUrl ? 'Available' : 'Not Found'}
                                            </Label>
                                        </Table.Cell>
                                        <Table.Cell>
                                            <span style={{ color: '#888', italic: true }}>N/A (Common Master)</span>
                                        </Table.Cell>
                                        <Table.Cell>
                                            <Button
                                                icon
                                                color="green"
                                                size="tiny"
                                                disabled={!clusterMasterUrl}
                                                onClick={() => this.handleDownload(clusterMasterUrl)}
                                            >
                                                <Icon name="download" />
                                            </Button>
                                        </Table.Cell>
                                    </Table.Row>
                                </Table.Body>
                            </Table>

                            {/* Section 3: Process Actions */}
                            <div style={{ marginTop: 20, textAlign: 'right' }}>
                                <Label size="large" color={selectedBrand.status === 'Completed' ? 'green' : selectedBrand.status === 'Processing' ? 'orange' : selectedBrand.status === 'Failed' ? 'red' : 'grey'} style={{ marginRight: 15 }}>
                                    Status: {selectedBrand.status || 'Pending'}
                                </Label>
                                <Button
                                    color="orange"
                                    onClick={this.handleStartProcess}
                                    disabled={!selectedBrand.vt_file || selectedBrand.status === 'Processing'}
                                >
                                    <Icon name="play" /> Start / Restart
                                </Button>
                                <Button
                                    color="green"
                                    disabled={!selectedBrand.output_file_url || selectedBrand.status !== 'Completed'}
                                    onClick={() => this.handleDownload(selectedBrand.output_file_url)}
                                >
                                    <Icon name="download" /> Download Output
                                </Button>
                            </div>

                            {selectedBrand.error && selectedBrand.status !== 'Processing' && (
                                <Message negative style={{ marginTop: 15 }}>
                                    <Message.Header>Processing Error</Message.Header>
                                    <p>{selectedBrand.error}</p>
                                </Message>
                            )}
                        </div>
                    )}
                </Segment>
            </Segment>
        );
    }
}

export default HeroBrandAutomation;
